import React, {
  Ref,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { useForm } from 'react-hook-form';
import {
  InputText,
  ErrorField,
  StyledSelect,
} from '~/lib/HooksFormFields';
import PresencesForm from '../../PresencesForm';
import { useAccountsList } from '~/hooks/account';
import styles from './collaborator-form.module.scss';
import { userFunctions, PROFILE_FIRST_LAST_NAME_MAX_LENGTH } from '~/constants';

interface CollaboratorFormHandler {
  getCollaborator: () => void,
}

const CollaboratorForm = ({ type, from }
: { type: string, from?: string }, ref: Ref<CollaboratorFormHandler>) => {
  const {
    data: list,
  } = useAccountsList();
  const {
    days = [],
  } = list;

  const {
    control,
    setValue,
    reset,
    getValues,
    trigger,
    formState: { errors },
  } = useForm();
  const errorsForm: any = errors;

  useImperativeHandle(ref, () => ({
    getCollaborator: async () => {
      const isValid = await trigger();
      let data = null;
      if (isValid) {
        data = getValues();
        reset();
      }
      return data;
    },
  }), []);

  return (
    <div className={styles.form}>
      <div className={styles.row} >
        <div className={styles.containerField}>
          <InputText
            label="Prénom du collaborateur"
            name="profile.firstName"
            control={control}
            maxlength={PROFILE_FIRST_LAST_NAME_MAX_LENGTH}
            rules={{
              required: 'Ce champs est obligatoire',
              maxLength: {
                value: PROFILE_FIRST_LAST_NAME_MAX_LENGTH,
                message: `${PROFILE_FIRST_LAST_NAME_MAX_LENGTH} caractères maximum`,
              },
            }}
          />
          {errorsForm?.profile?.firstName && (
            <ErrorField message={errorsForm.profile.firstName.message} />
          )}
        </div>
        <div className={styles.containerField}>
          <InputText
            label="Nom  du collaborateur"
            name="profile.lastName"
            control={control}
            maxlength={PROFILE_FIRST_LAST_NAME_MAX_LENGTH}
            rules={{
              required: 'Ce champs est obligatoire',
              maxLength: {
                value: PROFILE_FIRST_LAST_NAME_MAX_LENGTH,
                message: `${PROFILE_FIRST_LAST_NAME_MAX_LENGTH} caractères maximum`,
              },
            }}
          />
          {errorsForm?.profile?.lastName && (
            <ErrorField message={errorsForm.profile.lastName.message} />
          )}
        </div>
      </div>
      {type === 'magasin' && (
        <div className={styles.row}>
          <div className={styles.containerField}>
            <StyledSelect
              label="Fonction  du collaborateur"
              name='userFunction'
              control={control}
              rules={{
                required: 'Ce champs est obligatoire',
              }}
              options={userFunctions}
            />
            {errors?.userFunction && <ErrorField message={errors?.userFunction?.message} />}
          </div>
        </div>
      )}
      <PresencesForm
        control={control}
        setValue={setValue}
        isCollaborator
        from={from || 'registerCollaborator'}
        days={days}
        errors={errors.presences || []}
      />
    </div>
  );
};

export default forwardRef(CollaboratorForm);
